<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p4_us-movement-box">
  <!-- Artboard: xs -->
  <div
    id="g-p4_us-movement-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.75514874141877;"
  >
    <div
      id="g-p4_us-movement-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_us-movement-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs"
      style="top:1.6018%;left:42.9626%;width:53.9394%;"
    >
      <p class="g-pstyle0">KC-135 Stratotanker and</p>
      <p class="g-pstyle0">KC-46 Pegasus</p>
      <p>
        More than 31 U.S. refuelling aircraft were sent to bases across Europe.
      </p>
    </div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs"
      style="top:19.222%;left:66.4943%;width:31.8182%;"
    >
      <p class="g-pstyle0">USS Nimitz</p>
      <p>
        The carrier is sailing toward the Middle East and can hold more than 60
        aircraft, including fighter jets.
      </p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:43.9165%;margin-top:-3.9px;left:56.5905%;margin-left:-25.5px;width:51px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:45.5183%;margin-top:-3.9px;right:59.6499%;width:65px;"
    >
      <p class="g-pstyle2">ISRAEL</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:61.2124%;margin-top:-7.5px;left:59.3941%;width:106px;"
    >
      <p class="g-pstyle3">USS Carl Vinson</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-artwork g-aiAbs"
      style="top:64.7597%;left:3.0187%;width:43.9394%;"
    >
      <p class="g-pstyle0">B-52 bombers and</p>
      <p class="g-pstyle0">fighter aircrafts</p>
      <p>Spotted at Diego Garcia base in the Chagos Islands.</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p4_us-movement-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.82258064516129;"
  >
    <div
      id="g-p4_us-movement-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_us-movement-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs"
      style="top:3.2258%;left:41.636%;width:36.8627%;"
    >
      <p class="g-pstyle0">KC-135 Stratotanker and</p>
      <p class="g-pstyle0">KC-46 Pegasus</p>
      <p>
        More than 31 U.S. refuelling aircraft were sent to bases across Europe.
      </p>
    </div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs"
      style="top:27.4194%;left:75.098%;width:25.6863%;"
    >
      <p class="g-pstyle0">USS Nimitz</p>
      <p>
        The carrier is sailing toward the Middle East and can hold more than 60
        aircraft, including fighter jets.
      </p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:43.7094%;margin-top:-6px;left:56.6558%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:45.161%;margin-top:-6px;right:59.4024%;width:73px;"
    >
      <p class="g-pstyle2">ISRAEL</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-artwork g-aiAbs"
      style="top:58.5484%;left:73.7255%;width:24.902%;"
    >
      <p class="g-pstyle0">USS Carl Vinson</p>
      <p>
        The carrier strike group was already stationed in the Arabian Sea
        earlier this year to support strikes against the Houthis.
      </p>
    </div>
    <div
      id="g-ai1-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:70.4997%;margin-top:-29.1px;left:2.8488%;width:182px;"
    >
      <p class="g-pstyle3">B-52 bombers and</p>
      <p class="g-pstyle3">fighter aircrafts</p>
      <p class="g-pstyle4">Spotted at Diego Garcia base in</p>
      <p class="g-pstyle4">the Chagos Islands.</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p4_us-movement-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.01382488479263;"
  >
    <div
      id="g-p4_us-movement-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_us-movement-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs"
      style="top:26.2673%;left:72.448%;width:26.3636%;"
    >
      <p class="g-pstyle0">USS Nimitz</p>
      <p>
        The carrier is sailing toward the Middle East and can hold more than 60
        aircraft, including fighter jets.
      </p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs"
      style="top:26.2673%;left:2.6749%;width:18.6364%;"
    >
      <p class="g-pstyle0">KC-135 Stratotanker and KC-46 Pegasus</p>
      <p>
        More than 31 U.S. refuelling aircraft were sent to bases across Europe.
      </p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:40.6295%;margin-top:-6.5px;left:56.5708%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:42.1656%;margin-top:-6.5px;right:56.5276%;width:73px;"
    >
      <p class="g-pstyle2">ISRAEL</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-artwork g-aiAbs"
      style="top:55.7604%;left:72.448%;width:27.1212%;"
    >
      <p class="g-pstyle0">USS Carl Vinson</p>
      <p>
        The carrier strike group was already stationed in the Arabian Sea
        earlier this year to support strikes against the Houthis.
      </p>
    </div>
    <div
      id="g-ai2-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:67.9387%;margin-top:-34.3px;left:2.4954%;width:209px;"
    >
      <p class="g-pstyle3">B-52 bombers and</p>
      <p class="g-pstyle3">fighter aircrafts</p>
      <p class="g-pstyle4">Spotted at Diego Garcia base in</p>
      <p class="g-pstyle4">the Chagos Islands.</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-20 17:47 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-20 17:47 -->
<!-- ai file: p4_us-movement.ai -->
<style lang="scss">
  #g-p4_us-movement-box,
  #g-p4_us-movement-box .g-artboard {
    margin: 0 auto;
  }
  #g-p4_us-movement-box p {
    margin: 0;
  }
  #g-p4_us-movement-box .g-aiAbs {
    position: absolute;
  }
  #g-p4_us-movement-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p4_us-movement-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p4_us-movement-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p4_us-movement-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p4_us-movement-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) {
      #g-p4_us-movement-md {
        display: block !important;
      }
    }
  }
  #g-p4_us-movement-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p4_us-movement-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_us-movement-xs .g-pstyle0 {
    font-weight: 700;
    color: rgb(0, 79, 157);
  }
  #g-p4_us-movement-xs .g-pstyle1 {
    font-weight: 700;
    line-height: 7px;
    height: 7px;
    letter-spacing: 0.2em;
    font-size: 10px;
    text-align: center;
    color: rgb(92, 92, 92);
  }
  #g-p4_us-movement-xs .g-pstyle2 {
    font-weight: 700;
    line-height: 7px;
    height: 7px;
    letter-spacing: 0.2em;
    font-size: 10px;
    text-align: right;
    color: rgb(92, 92, 92);
  }
  #g-p4_us-movement-xs .g-pstyle3 {
    font-weight: 700;
    height: 14px;
    color: rgb(0, 79, 157);
  }
  #g-p4_us-movement-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p4_us-movement-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_us-movement-sm .g-pstyle0 {
    font-weight: 700;
    color: rgb(0, 79, 157);
  }
  #g-p4_us-movement-sm .g-pstyle1 {
    font-weight: 700;
    line-height: 11px;
    height: 11px;
    letter-spacing: 0.2em;
    text-align: center;
    color: rgb(92, 92, 92);
  }
  #g-p4_us-movement-sm .g-pstyle2 {
    font-weight: 700;
    line-height: 11px;
    height: 11px;
    letter-spacing: 0.2em;
    text-align: right;
    color: rgb(92, 92, 92);
  }
  #g-p4_us-movement-sm .g-pstyle3 {
    font-weight: 700;
    height: 14px;
    color: rgb(0, 79, 157);
  }
  #g-p4_us-movement-sm .g-pstyle4 {
    height: 14px;
  }
  #g-p4_us-movement-md {
    position: relative;
    overflow: hidden;
  }
  #g-p4_us-movement-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_us-movement-md .g-pstyle0 {
    font-weight: 700;
    color: rgb(0, 79, 157);
  }
  #g-p4_us-movement-md .g-pstyle1 {
    font-weight: 700;
    line-height: 12px;
    height: 12px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(92, 92, 92);
  }
  #g-p4_us-movement-md .g-pstyle2 {
    font-weight: 700;
    line-height: 12px;
    height: 12px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: right;
    color: rgb(92, 92, 92);
  }
  #g-p4_us-movement-md .g-pstyle3 {
    font-weight: 700;
    height: 17px;
    color: rgb(0, 79, 157);
  }
  #g-p4_us-movement-md .g-pstyle4 {
    height: 17px;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
